import React from "react";
import logo from "../Assets/logo_all_white.png";

function Pre(props) {
  return (
    <div id={props.load ? "preloader" : "preloader-none"}>
      {props.load && (
        <img src={logo} alt="동진에어텍" className="preloader-logo" />
      )}
    </div>
  );
}

export default Pre;
